import React from 'react';

import { Modal } from 'react-bootstrap';

import LedgerEntry from '../../../types/LedgerEntry';

import PriceBreakdown from './PriceBreakdown';

type Props = {
  entry: LedgerEntry;
  onClose: () => void;
};

// eslint-disable-next-line import/no-unused-modules
export default function PriceBreakdownModal({ entry, onClose }: Props) {
  const handleCloseClick = () => onClose();

  return (
    <Modal show>
      <Modal.Header>
        <b>Price breakdown</b>
      </Modal.Header>
      <Modal.Body className='price-breakdown-modal__body'>
        <PriceBreakdown entry={entry} />
      </Modal.Body>
      <Modal.Footer>
        <button
          className='btn btn-primary'
          type='button'
          onClick={handleCloseClick}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}
